import { render, staticRenderFns } from "./ResetPasswordV2Component.vue?vue&type=template&id=7f7eda3a&"
import script from "./ResetPasswordV2Component.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordV2Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports